<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import GoAlert from 'svelte-icons/go/GoAlert.svelte';

export let tone = 'cloud';
</script>

<strong class="alert">
    <div
        class="icon"
        class:red={tone === 'cloud' || tone === 'combined'}
        class:alert-attention-icon={tone === 'websearch'}
    ><GoAlert /></div>
    <slot />
</strong>
